import { Typography } from '@mui/material';
import AttachmentsList from 'components/shared/data/attachments_list';
import DataBlock from 'components/shared/data/data_block';
import DataCard from 'components/shared/data/data_card';
import DataLabel from 'components/shared/data/data_label';
import { Flex } from 'components/shared/flex';
import ThemedButton from 'components/shared/themed_button';
import { ProofreadEvent } from 'entities/proofread_event';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MypageRouteHelper } from 'routes/mypage';
import { chunk } from 'utils/utils';
import { ProofreadEventViewModel } from 'view_models/proofread_event';

type ProofreadEventDataCardProps = {
  proofreadEvent: ProofreadEvent | undefined;
  showDetail?: boolean;
};
const ProofreadEventDataCard: React.FC<ProofreadEventDataCardProps> = (props) => {
  const [vm, setVm] = useState(new ProofreadEventViewModel(props.proofreadEvent || {}));
  const navigate = useNavigate();

  useEffect(() => {
    if (props.proofreadEvent) {
      setVm(new ProofreadEventViewModel(props.proofreadEvent));
    }
  }, [props.proofreadEvent]);

  // 値が設定されている校正管理情報のみ抽出し、3つずつの行に分割
  const exAttrRows = chunk(
    (props.proofreadEvent?.exAttributes || []).filter(
      (attr) => attr.exAttributeValue?.id && attr.exAttributeValue?.value
    ),
    3
  );

  return (
    <DataCard>
      <Flex justifyContent="space-between">
        <Typography variant="h6">校正履歴</Typography>
        {props.proofreadEvent && props.showDetail && (
          <ThemedButton
            color="secondary"
            onClick={() => {
              const planId = props.proofreadEvent?.proofreadPlanId;
              if (planId) {
                navigate(MypageRouteHelper.proofreadPlanShow(planId));
              } else {
                console.error('error: proofreadPlanId is null');
              }
            }}
          >
            詳細
          </ThemedButton>
        )}
      </Flex>
      {props.proofreadEvent ? (
        <>
          <DataBlock>
            <DataLabel label="校正月" value={vm.getScheduledDate()} />
            <DataLabel label="校正価格" value={vm.getPrice()} />
          </DataBlock>
          <DataBlock>
            <DataLabel label="委託先" value={vm.getSupplier()} />
            <DataLabel label="担当者" value={vm.getUser()} />
            <DataLabel label="ステータス" value={vm.getStatusLabel()} />
          </DataBlock>
          <DataBlock noBorder={exAttrRows.length === 0}>
            <AttachmentsList fileAttachments={props.proofreadEvent.attachments || []} />
          </DataBlock>
          {exAttrRows.length > 0 && (
            <DataBlock noBorder>
              <div style={{ width: '100%' }}>
                <DataLabel label="校正管理情報" value="" />
                <div style={{ paddingLeft: 16, marginTop: 12 }}>
                  {exAttrRows.map((row, rowIndex) => (
                    <div
                      key={rowIndex}
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: 8,
                        padding: '12px 0',
                        borderBottom: rowIndex < exAttrRows.length - 1 ? '1px solid #cccccc' : 'none',
                      }}
                    >
                      {row.map((attr, i) => {
                        let value = attr.exAttributeValue?.value || '-';
                        if (attr.exColumn?.inputType === 'price' && attr.exAttributeValue?.value) {
                          value = `¥${parseInt(attr.exAttributeValue.value).toLocaleString()}`;
                        }
                        return <DataLabel key={attr.exColumn?.id ?? i} label={attr.exColumn?.name} value={value} />;
                      })}
                    </div>
                  ))}
                </div>
              </div>
            </DataBlock>
          )}
        </>
      ) : (
        <span>校正履歴を選択してください</span>
      )}
    </DataCard>
  );
};

export default ProofreadEventDataCard;
